<template>
    <div class="w-full">
        <div class="w-full mx-auto mt-20">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    MASTER JADWAL DOKTER KHUSUS
                </h1>
            </div>
            <div class="w-full">
                 <FlashMessage class="mt-5 mb-5" />
            </div>
            <div class="w-full mt-5 flex">
                        <DateInput
                            v-model="tglPeriksa"
                            class="w-full grow mr-5"
                            id="tgl_periksa"
                            label="PILIH TANGGAL PERIKSA"
                            :custError="
                                $page.props.errors.getJadwalDokterKhusus
                                    ? $page.props.errors.getJadwalDokterKhusus.tglPeriksa
                                    : ''
                            "
                        />
                        <button
                            @click.prevent="getJadwalKhusus"
                            class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs"
                        >
                            LIHAT JADWAL
                        </button>
                </div>
            <div v-if="jadwalDokterKhusus" class="w-full my-3">
                <p class=" font-poppins font-bold text-center text-xl">Tanggal Periksa: {{ jadwalDokterKhusus.hari }}</p>
                <Link class="btn-primary w-1/2 mt-2 mx-auto mb-2" :href="`/admin/jadwal_dokter_khusus/${tglPeriksa}/create`">
                    <span>Tambah</span>
                    <span class="hidden md:inline">&nbsp;Jadwal Dokter Khusus</span>
                </Link>
                <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300 mb-8">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold bg-amber-100">
                                <th class="py-2 px-3 text-center text-sm">Poliklinik</th>
                                <th class="py-2 px-3 text-center text-sm">Dokter</th>
                                <th class="py-2 px-3 text-center text-sm">Hari</th>
                                <th class="py-2 px-3 text-center text-sm">Jam Praktik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="jadwalDokter in jadwalDokterKhusus.data"
                                :key="jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari"
                                class="hover:bg-gray-100"
                            >
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer"
                                        :href="`/admin/jadwal_dokter_khusus/${tglPeriksa}/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                    >
                                        {{ jadwalDokter.layanan.FS_NM_LAYANAN }}
                                    </Link>
                                </td>
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer "
                                        :href="`/admin/jadwal_dokter_khusus/${tglPeriksa}/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                        tabindex="-1"
                                    >
                                    {{ jadwalDokter.dokter.FS_NM_PEG }}
                                    </Link>
                                </td>
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer "
                                        :href="`/admin/jadwal_dokter_khusus/${tglPeriksa}/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                        tabindex="-1"
                                    >
                                    {{ jadwalDokter.hari.fs_nm_hari }}
                                    </Link>
                                </td>
                                <td class="border-r border-t">
                                    <Link
                                        class="flex items-center px-3 py-2 text-sm select-none cursor-pointer "
                                        :href="`/admin/jadwal_dokter_khusus/${tglPeriksa}/${jadwalDokter.fs_kd_layanan+'-'+jadwalDokter.fs_kd_dokter+'-'+jadwalDokter.fs_kd_hari}/edit`"
                                        tabindex="-1"
                                    >
                                    {{ jadwalDokter.fs_jam_mulai + ' - ' +  jadwalDokter.fs_jam_selesai}}
                                    </Link>
                                </td>
                            </tr>
                            <tr v-if="jadwalDokterKhusus.data.length === 0">
                                <td class="px-3 py-2 border-r border-t" colspan="4">
                                    Belum ada data jadwal dokter.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import Pagination from "../../../Shared/Pagination.vue";
import SearchFilter from "../../../Shared/SearchFilter.vue";
import FlashMessage from "../../../Shared/FlashMessage.vue";
import DateInput from "../../../Shared/DateInput.vue";

export default {
    data() {
        return {
            tglPeriksa: '',
            jadwalDokterKhusus: ''
        }
    },
    components: {
        Pagination,
        Link,
        SearchFilter,
        FlashMessage,
        DateInput
    },
    layout: LayoutAdmin,
    watch: {
        tglPeriksa(){
            this.jadwalDokterKhusus = '';
        }
    },
    methods: {
        getJadwalKhusus(){
            this.$inertia.get(
                "/admin/jadwal_dokter_khusus_ajax",
                {
                    tglPeriksa: this.tglPeriksa
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.jadwalDokterKhusus = page.props.additional.jadwalDokterKhusus;
                        console.log(this.jadwalDokterKhusus);
                    },
                    errorBag: "getJadwalDokterKhusus",
                },
                
            );
        }
    },
};
</script>
